import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import * as _ from 'lodash';

import { environment } from 'src/environments/environment';
import { UtilService } from 'src/app/modules/shared/services/util.service';
import { CouponsService } from 'src/app/modules/retailer/services/coupons.service';

@Component({
  selector: 'app-demo-national-coupon-list',
  templateUrl: './demo-national-coupon-list.component.html',
  styleUrls: ['./demo-national-coupon-list.component.scss']
})
export class DemoNationalCouponListComponent implements OnInit {

  public loginData: any;

  public coupons: any = [];
  public couponsPage: number = 1;
  public couponsCount: number = 0;
  public couponsLoading: boolean = false;
  public displayType: string; // grid/list

  public selectedStore: any = 0; // Always 0 for demo coupon list
  public couponSource: string = 'national'; // national/cpg/retailer
  public couponStatus: string = 'active'; // expired/active/upcoming
  public demoStatus: any = 1; // Always 1 for demo coupon list

  constructor(
    private _router: Router,
    private _utilService: UtilService,
    private _couponsService: CouponsService
  ) { }

  ngOnInit(): void {
    this.getStorageData();
  }

  // Back to coupon list
  onBackClick(){
    this._router.navigate(['/retailer/coupons'], {
      state: {}
    });
  }

  async getStorageData() {
    this.loginData = await this._utilService.getStorageData('R_LOGIN');

    this.displayType = 'grid'; // Default display type
    this.couponsPage = 1;
    this.getCoupons();
  }

  // Change  display type
  changeDisplayType(type: string) {
    this.displayType = type;
  }

  // Get coupons
  getCoupons() {
    this.coupons = [];
    this.couponsCount = 0;
    this.couponsLoading = true;

    this._couponsService.getCoupons(this.loginData.token, this.loginData.user_details.provider_type, this.loginData.user_details.provider_id, this.loginData.user_details.provider_id, this.selectedStore, this.couponSource, this.couponStatus, this.couponsPage, this.demoStatus).subscribe(async getCouponsResponse => {
      this.couponsLoading = false;

      if (getCouponsResponse.status === true) { // Success
        this.coupons = getCouponsResponse.coupons;
        this.couponsCount = getCouponsResponse.total_count;
      } else {
        this._utilService.showToast(getCouponsResponse.message, '', 'error', {});
      }
    }, error => { // Error from getCoupons
      this.couponsLoading = false;
    });
  }

  // Coupons page change
  onCouponsPageChange(event: any) {
    this.couponsPage = event;
    this.getCoupons();
  }

  // On coupon action - Accept/Reject
  onCouponReviewAction (event: any) {
    this.getCoupons();
  }

}
